import { initializeApp } from "firebase/app";
import { getAuth, updateProfile } from "firebase/auth";
import { getMessaging } from "firebase/messaging";
import {
  getFirestore,
  collection,
  getDocs,
  getDoc,
  setDoc,
  query,
  where,
  addDoc,
  updateDoc,
  deleteDoc,
  doc,
  orderBy,
  limit,
  onSnapshot,
  serverTimestamp,
  startAfter
} from "firebase/firestore";
import {
  getStorage,
  ref as storageRef,
  uploadBytes,
  getDownloadURL,
  deleteObject
} from "firebase/storage";
import { getDatabase, ref, set, get, onValue, push } from "firebase/database";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL
};

const app = initializeApp(firebaseConfig);

const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);
const database = getDatabase(app);
const messaging = typeof window !== 'undefined' ? getMessaging(app) : null;

export {
  auth,
  updateProfile,
  db,
  storage,
  database,
  messaging,
  storageRef,
  uploadBytes,
  getDownloadURL,
  deleteObject,
  ref,
  set,
  get,
  onValue,
  push,
  collection,
  getDocs,
  getDoc,
  setDoc,
  query,
  where,
  addDoc,
  updateDoc,
  deleteDoc,
  doc,
  orderBy,
  limit,
  onSnapshot,
  serverTimestamp,
  startAfter
};
